import { render, staticRenderFns } from "./WineItem.vue?vue&type=template&id=18b24bdb&scoped=true&"
import script from "./WineItem.vue?vue&type=script&lang=js&"
export * from "./WineItem.vue?vue&type=script&lang=js&"
import style0 from "./WineItem.vue?vue&type=style&index=0&id=18b24bdb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b24bdb",
  null
  
)

export default component.exports